<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'

const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_news_intro')
}

const isOnNewsSection = computed(() => {
  return route.path.startsWith('/news')
})

const goToNews = () => {
  router.push('/news')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/news.webm"
  >
    <template #text>
      <p class="pb-2">
        Hi, I'm your intelligence advisor!
      </p>
      <p class="pb-2">
        To keep you up to date with everything that is happening in your empire, you should visit your news section often.
      </p>
      <p class="pb-2">
        You'll receive reports on research breakthroughs, military engagements, diplomatic events, espionage activities, and much more.
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="hidden md:flex">
        Click on the "News" button in the top menu.
      </Alert>
      <Alert type="info" class="md:hidden">
        Click on the "Menu" in the right top of your screen, then select "News".
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnNewsSection" @click="goToNews" class="mr-2">
        Go to News
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Continue
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>